import src from "IMAGE";
export default { src, width: 191, height: 32, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADQ1PEU4OkJQPD9HWTU3PkY4OkFPODpBTjQ2PEU6PERVgcMH98VIVhAAAAAASUVORK5CYII="};
